import React from 'react';
import { FilterPassport, PeopleFilterName } from '@/types/api';
import { useAtom } from 'jotai';
import { approvalFilter, approvalTempFilter } from '@/recoil/atom';
import { Container } from '@/components/Approval/LeftContainer/PeopleFilter/PassportCheckBox/styles';
import PassportCheckItem from '@/components/Approval/Common/PassportCheckItem';

export type PassportCheckBoxProps = {
  filterName: PeopleFilterName;
  onChange: (isChecked: boolean, passport: FilterPassport) => void;
  handleError(): void;
  isTarget?: boolean;
  onMouseMove?(idx?: number): void;
  cursorIndex?: number;
  /** 검색어 — 이름에서 매칭 부분을 파랑으로 하이라이트 */
  keyword?: string;
};

const PassportCheckBox = (props: PassportCheckBoxProps & FilterPassport) => {
  const {
    filterName,
    onChange,
    handleError,
    isTarget,
    onMouseMove,
    cursorIndex,
    keyword,
    ...passport
  } = props;
  const {
    passportId,
    profileImageUrl,
    positionName,
    name,
    divisionName,
    departmentName,
  } = passport;

  const [filters, setFilters] = useAtom(approvalFilter);
  const [tempFilters, setTempFilters] = useAtom(approvalTempFilter);

  const isChecked = filters[filterName].some(
    (res: FilterPassport) => res.passportId === passportId,
  );

  const handleChange = () => {
    if (isChecked) {
      setFilters({
        ...filters,
        [filterName]: filters[filterName].filter(
          (res: FilterPassport) => res.passportId !== passportId,
        ),
      });
    } else {
      if (filters[filterName].length >= 10) {
        handleError();
      } else {
        setFilters({
          ...filters,
          [filterName]: [
            ...filters[filterName],
            {
              passportId,
              profileImageUrl,
              positionName,
              name,
              divisionName,
              departmentName,
            },
          ],
        });
      }
    }

    onChange(!isChecked, passport);

    if (
      !(tempFilters[filterName] || []).some(
        (item) => item.passportId === passportId,
      )
    ) {
      setTempFilters({
        ...tempFilters,
        [filterName]: [
          ...(tempFilters[filterName] || []),
          {
            passportId,
            profileImageUrl,
            positionName,
            name,
            divisionName,
            departmentName,
          },
        ],
      });
    }
  };

  const handleMouseMove = () => {
    onMouseMove && onMouseMove(cursorIndex);
  };

  return (
    <Container
      isTarget={isTarget}
      onMouseMove={handleMouseMove}
      onClick={handleChange}
    >
      <PassportCheckItem
        passportId={passportId}
        name={name}
        positionName={positionName}
        divisionName={divisionName}
        departmentName={departmentName}
        profileImageUrl={profileImageUrl}
        isChecked={isChecked}
        onClick={handleChange}
        keyword={keyword}
      />
    </Container>
  );
};

export default PassportCheckBox;
